/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const CdsSoggettoR = t.interface({});

// optional attributes
const CdsSoggettoO = t.partial({
  creditorInstitutionCode: t.string,

  creditorInstitutionDescription: t.string,

  id: t.Integer
});

export const CdsSoggetto = t.intersection(
  [CdsSoggettoR, CdsSoggettoO],
  "CdsSoggetto"
);

export type CdsSoggetto = t.TypeOf<typeof CdsSoggetto>;
